<template>
    <div class='wrap'>
        <p class='onLineTitle'>
            多方支持与合作
        </p>
        <ul class="support img_scalc">
            <li v-for="(item,index) in supportList" :key="index" class="">
                <img :src="item.img" >
                <span :class="{'largetWidth':(index==3 || index== 7|| index== 11|| index== 10)}">{{item.text}}</span>
            </li>
        </ul>
        <p class='onLineTitle'>
            商业合作伙伴
        </p>
        <ul class="business clearfix">
            <li v-for="(item,index) in business" :key="index">
                <img :src="item.img" >
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        data(){
            return{

      supportList: [
        {
          img: require("./../../assets/newPCImg/Hos_xiehe.png"),
          text: "北京协和医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_301.png"),
          text: "北京301医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_ertong.png"),
          text: "北京儿童医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_kouqiang.png"),
          text: "北京大学口腔医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_tongren.png"),
          text: "同仁医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_zhaowai.png"),
          text: "北京阜外医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_xuanwu.png"),
          text: "宣武医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_beida.png"),
          text: "北京大学人民医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_anzhen.png"),
          text: "安贞医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_tiantan.png"),
          text: "北京天坛医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_yikezhongliu.png"),
          text: "医科院肿瘤医院"
        },
        {
          img: require("./../../assets/newPCImg/Hos_zhongliu.png"),
          text: "北京大学肿瘤医院"
        }
      ],

      business: [

        {
          img: require("./../../assets/Pc/footImg/Sup_yidong.png")
        },
        {
          img: require("./../../assets/Pc/footImg/Sup_huaxiheyi.png")
        },
        {
          img: require("./../../assets/Pc/footImg/Sup_xie.png")
        },
        {
          img: require("./../../assets/Pc/footImg/Sup_jia.png")
        },
      ]
            }
        }
    }
</script>
<style lang="less" scoped>
    
.onLineTitle{
    font-size:24px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:32px;
    text-align:center; margin-bottom: 52px;
}
.support{
    display: flex; justify-content: space-between;flex-wrap:wrap;
    width: 90%; margin:0 auto;
    li{
        width: 160px; margin: 0 30px 60px; height: 140px;text-align: center;
        img{
            display: block; width: 100%; height: 104px;
        }
        span{
            height:20px;
            font-size:20px; 
            font-family:PingFangSC-Light;
            font-weight:300;
            color:rgba(56,56,55,1);
            transform: scale(0.9)
        }
        .largetWidth{
            /* transform: scale(0.7) */
            width: 140%; display: inline-block;transform: translateX(-13%)
        }
        &:nth-child(1){
            img{
                transform: scale(1.4)
            }
        }
        &:nth-child(2){
            img{
                transform: scale(1.2)
            }
        }
    }
}
/* 商业支持 */
.business{
    display: flex; justify-content: space-between;flex-wrap:wrap; height: 112px;
    width: 94%; margin:0 auto 86px;
    li{
        width: 147px; height: 112px;
        img{
            display: block; width: 100%;
        }
        &:nth-child(2){
            width: 200px;
            img{
                transform: scale(1.4);
                margin: 12px 0 0 20px;
            }
        }

        &:nth-child(3){
            width: 140px;
            img{
                transform: scale(0.6) translateY(-34px)
            }
        }
        &:nth-child(4){
            img{
                transform: scale(0.9) translateY(-14px)
            }
        }
        &:nth-child(1){
            img{
                padding-top: 40px; transform: scale(1)
            }
        }
    }
}
</style>